import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ApiClient,
  AppointmentInfo,
  IApiClient,
  QuoteInfo,
  QuoteRequest,
  QuotesListboxInfo,
  UpdateQuoteRequest,
} from '../sdk/sdk';

@Injectable({
  providedIn: 'root',
})
export class QuoteService {
  private readonly sdk: IApiClient = inject(ApiClient);

  updateQuote(id: string, body: UpdateQuoteRequest): Observable<QuoteInfo> {
    return this.sdk.updateQuote(id, body);
  }

  generateQuote(body: QuoteRequest): Observable<AppointmentInfo> {
    return this.sdk.generateQuote(body);
  }

  getQuotes(branchIds: string[], startDate?: Date, endDate?: Date): Observable<QuotesListboxInfo> {
    return this.sdk.getQuotes(branchIds, startDate, endDate);
  }
}
